import React from "react";
import buzzed from "../images/buzzed.jpeg";

function RatingPage({ onSelect }) {
  return (
    <div className="container">
      <div className="card">
        <img src={buzzed} alt="restaurant" className="restaurant-image" />

        <h2 className="title">Buzzed Coffee Bar</h2>
        <p className="subtitle">How was your dining experience today?</p>

        <div className="emoji-row">
          <div className="emoji-option" onClick={() => onSelect(1)}>
            <span>😢</span>
            <p>Not good</p>
          </div>

          <div className="emoji-option" onClick={() => onSelect(2)}>
            <span>😐</span>
            <p>Okay</p>
          </div>

          <div className="emoji-option" onClick={() => onSelect(3)}>
            <span>😊</span>
            <p>Great</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RatingPage;